import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./navbar.css";
import logo from "../Images/aquila12.png";
import { HashLink as Link } from "react-router-hash-link";

const Navbar = () => {
  //* Setting mobile nav
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  //* Change nav color when scrolling
  const [color, setColor] = useState(false)
  const changeColor = () => {
    if(window.scrollY >= 90){
      setColor(true)
    }else{
      setColor(false)
    }
  }

  window.addEventListener('scroll', changeColor)

  //* Close menu on click
  const closeMenu = () => setClick(false);
  return (
    <div className={color ? 'header header-bg' : 'header'}>
      <nav className='navbar'>
        <a href="/" className="logo">
          <img src={logo} alt="logo" />
        </a>
        <div className="hamburger" onClick={handleClick}>
          {click ? (
            <FaTimes size={30} style={{ color: "#f80505" }} />
          ) : (
            <FaBars size={30} style={{ color: "#ffffff" }} />
          )}
        </div>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <Link to="#homePage" smooth>
            <li className="nav-item" onClick={closeMenu}>
              Home
            </li>
          </Link>

          <Link to="#aboutProject" smooth>
            <li className="nav-item" onClick={closeMenu}>
              Project
            </li>
          </Link>
          <Link to="#aboutUs" smooth>
            <li className="nav-item" onClick={closeMenu}>
              About us
            </li>
          </Link>

          <li className="nav-item" id="playNow">
            <a href="#demo" onClick={closeMenu}>
              Play now
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
